var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoemails(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 206,
    viewBox: "0 0 290 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.9355 73.0476L154.588 7.8652C156.299 5.07961 161.313 1.17977 167.678 7.8652C174.044 14.5506 223.892 54.1057 248.02 73.0476V75.3869",
    stroke: "#FB7C51",
    strokeWidth: 0.611017
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.117 129.807C121.476 111.326 72.1924 74.3633 72.1924 74.3633V187.304",
    stroke: "#FB7C51",
    strokeWidth: 0.782608
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174.227 129.688L248.084 74.9023L246.882 189.568",
    stroke: "#FB7C51",
    strokeWidth: 0.782608
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2237 191.927L246.742 189.638C226.289 173.327 184.924 140.249 173.946 129.272C162.969 118.294 155.02 120.111 151.654 124.685C146.131 130.209 127.525 146.33 97.285 166.628C67.0452 186.926 65.4953 193.583 80.2237 191.927Z",
    stroke: "#FB7C51",
    strokeWidth: 0.782608
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9844 28.1582V90.7888L145.941 130.062L151.096 124.908C156.249 120.135 158.91 121.106 159.079 121.106C165.33 120.802 171.94 126.95 174.463 130.062L226.46 90.7888V53.8265L200.791 28.1582H92.9844Z",
    fill: "#FEFEFE",
    stroke: "#FB7C51",
    strokeWidth: 0.611017
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M200.791 30.7246C200.791 36.4952 200.791 42.2659 200.791 48.0365C200.791 50.475 200.791 52.9135 200.791 55.352C200.791 56.9295 202.189 56.3248 203.486 56.5213C207.372 57.1101 211.78 56.7698 215.679 56.6354C219.228 56.513 222.984 56.1363 226.459 56.1363",
    stroke: "#FB7C51",
    strokeWidth: 0.611017,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.53 66.404C137.039 66.404 150.548 66.433 164.057 66.404C174.51 66.3816 184.951 65.8906 195.401 65.8906",
    stroke: "#FB7C51",
    strokeWidth: 2.44407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.53 80.2637C132.16 81.5874 140.847 81.9282 149.569 82.1175C167.416 82.5048 178.076 81.5229 195.914 82.1175",
    stroke: "#FB7C51",
    strokeWidth: 2.44407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M123.53 98.1501C137.814 98.1501 152.12 97.878 166.396 98.4067",
    stroke: "#FB7C51",
    strokeWidth: 2.44407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7969 19.9941C76.0111 23.788 81.2646 27.4657 86.5904 31.0855",
    stroke: "#FB7C51",
    strokeWidth: 1.22203,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8643 7.63867C86.2346 12.1428 88.5122 16.902 88.7458 21.6842",
    stroke: "#FB7C51",
    strokeWidth: 1.22203,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.655 8.75421C100.065 11.6412 99.3528 14.4794 98.6093 17.3274C98.3761 18.221 97.8185 18.9033 97.512 19.7535",
    stroke: "#FB7C51",
    strokeWidth: 1.22203,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M289 188.635C280.805 187.145 272.533 187.595 264.208 187.595C260.264 187.595 256.361 187.809 252.437 188.211C250.258 188.435 248.414 188.294 246.35 188.982",
    stroke: "#FB7C51",
    strokeWidth: 1.83305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4863 193.837C43.9066 193.837 53.4595 194.2 62.8811 193.837C64.2185 193.786 65.2246 193.144 66.5797 193.144C68.3626 193.144 69.8503 192.684 71.569 192.47C73.6807 192.206 75.7187 192.573 77.8297 192.104",
    stroke: "#FB7C51",
    strokeWidth: 1.83305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M125.334 199.037C142.01 198.141 158.828 198.69 175.517 198.69C196.803 198.69 218.089 198.69 239.376 198.69C241.623 198.69 243.871 198.69 246.118 198.69C246.256 198.69 248.433 198.69 246.195 198.69C234.761 198.69 223.319 199.143 211.906 199.807C200.007 200.499 188.074 201.403 176.345 203.602C172.658 204.293 173.505 204.238 176.345 204.238C193.323 204.238 210.3 204.238 227.278 204.238",
    stroke: "#FB7C51",
    strokeWidth: 1.83305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M246.119 189.496C243.303 189.752 132.724 191.523 77.7866 192.376",
    stroke: "#FB7C51",
    strokeWidth: 1.83305
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M121.031 110.822C123.858 95.8464 110.335 72.9659 33.6372 101.247C17.115 99.2832 -11.3642 91.5255 6.89724 76.2065C25.1587 60.8876 57.551 53.13 71.4644 51.166",
    stroke: "#FB7C51",
    strokeWidth: 0.782608,
    strokeDasharray: "6.26 6.26"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M222.517 49.6006C219.005 46.5417 217.827 39.3364 241.209 34.9863C264.592 30.6361 272.703 10.5162 273.836 1",
    stroke: "#FB7C51",
    strokeWidth: 0.782608,
    strokeDasharray: "6.26 6.26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoemails);
export default __webpack_public_path__ + "static/media/noemails.5e7b8a4295ea30c8c9b020929897c818.svg";
export { ForwardRef as ReactComponent };